import React, { useEffect, useRef, useState } from 'react'
import {
    createComment, seeComments, deleteComment,
    createReplyComment, deleteReplyComment
} from '../../actions/commentActions'
import { connect, useDispatch } from 'react-redux';
import { fileUploadComment } from '../../actions/fileUploadActions'
import { useHistory } from "react-router-dom";
import CreateNewComment from './CreateNewComment';
import Comment from '../../containers/Post/Comment/Comment';
import inMemoryJWT from '../../auth/inMemoryJwt';
import { createReaction } from '../../actions/reactionActions';
import ModalReportPost from '../../containers/ReportContent/ModalReportPost';
import useModal from '../../utils/hooks/useModal';
import localStorage from '../../utils/hooks/useLocalStorage';


const CreateComment = ({ fileUploadComment, communityID, isProfessional, isMark, createComment, postID, seeComments, commentsList, deleteComment, createReplyComment, deleteReplyComment, isLoading, isLoadingComment }) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const [comment, setComment] = useState('')
    const [showReplyComents, setshowReplyComents] = useState('')
    const [dataFile, setDataFile] = useState(null)
    const [isOnlyAudio, setIsOnlyAudio] = useState(false)
    const [isShowAudio, setIsShowAudio] = useState(false)
    const [isShowGif, setIsShowGif] = useState(false)
    const [isOnlyGif, setIsOnlyGif] = useState(false)
    const [isShowReportPost, setIsShowReportPost] = useState(false)
    const imgSelector = useRef();
    const [refRules, isShowReport, setIsShowReport] = useModal(false)
    const [commentToReport, setCommentToReport] = useState(null)


    const selectReportPost = (e) => {
        e.stopPropagation()
        setIsShowReportPost(!isShowReportPost)
    }

    const onFileChange = (event) => {
        var filesTarget = event.target.files
        console.log()
        filesTarget[0].url = URL.createObjectURL(event.target.files[0])
        setDataFile({ [filesTarget[0].url]: { name: filesTarget[0].name, url: filesTarget[0].url, file: filesTarget[0] } })

    }

    console.log()

    const selectGif = (e) => {
        e.stopPropagation()
        setIsShowGif(!isShowGif)
    }

    const selectAudio = (e) => {
        e.stopPropagation()
        setIsShowAudio(!isShowAudio)
    }

    const myCallback = (event, code) => {
        setComment(comment + code.emoji)
    }
    const createReactionBubble = (id) => {
        dispatch(createReaction(id, 'RCT01', 0, false, false, 'comment', false))
    }
    const createReactionRecycle = (id) => {
        dispatch(createReaction(id, 'RCT02', 0, false, false, 'comment', false))
    }

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeComments(postID)
        })

    }, [postID])


    if (isLoading)
        return <div>Cargando...</div>
    if (!isLoading)
        return (
            <div className='parent-higth scroll-menu'>
                {
                    localStorage().getItem("typeProfile") != "warehouse" && (//TodoEcoCeoSocial
                        <CreateNewComment postID={postID} />
                    )
                }

                {commentsList.map((comment, index) => {
                    var dataUser = comment && (comment.userID ? comment.userID : comment.franchiseID ? comment.franchiseID : (comment.representativeID && comment.representativeID.userID) ? comment.representativeID.userID : {})
                    var contentModal = null
                    return (
                        <Comment
                            key={comment?._id}
                            setIsShowReport={setIsShowReport}
                            setCommentToReport={setCommentToReport}
                            communityID={communityID}
                            createReactionBubble={() => createReactionBubble(comment._id)}
                            createReactionRecycle={() => createReactionRecycle(comment._id)}
                            reactions={comment.reactions}
                            setshowReplyComents={setshowReplyComents}
                            showReplyComents={showReplyComents}
                            image={comment.image}
                            audio={comment.audio}
                            video={comment.video}
                            type={
                                comment.userID ? "EcoAmigo" : comment.franchiseID ? "EcoTienda" : comment.representativeID ? "EcoMaster" : ""
                            }
                            idCommentator={dataUser._id}
                            secondName={dataUser.lastname ? dataUser.lastname.split(" ")[0] : ""}
                            firstName={dataUser.name ? dataUser.name.split(" ")[0] : dataUser.socialReason}
                            srcImage={dataUser.picture && dataUser.picture.url ? dataUser.picture.url.small : dataUser.picture}
                            comment={comment.text}
                            commentId={comment?._id}
                            responses={comment?.responses}
                        />
                    )

                })}

                <ModalReportPost
                    closeModal={() => {
                        setIsShowReport(false)
                        // setUserToReport(null)
                    }}
                    displayModal={isShowReport}
                    idReported={commentToReport}

                    reportType={communityID ? 'postZone' : "content"}
                    {...(communityID && { communityID: communityID })}
                />

            </div >
        )
}

const mapStateToProps = (state) => {
    return {
        commentsList: state.comments.comments,
        isLoading: state.comments.isLoadingComments,
        isLoadingComment: state.comments.isLoadingCountReplyComments,
        isLoadingLikePost: state.comments.isLoadingLikePost
    }
}


export default connect(mapStateToProps, { fileUploadComment, createComment, seeComments, deleteComment, createReplyComment, deleteReplyComment })(CreateComment)
